<template>
  <div class="starter-page page-landing" @dblclick="handleDblClick()">
    <Gantt v-if="demoProjects" vie :tasks="demoProjects" :show-billing="showBilling" />
  </div>
</template>
<script>
import Gantt from "@/app/components/Gantt.vue";
import { mapMutations, mapState, mapActions } from "vuex";

export default {
  name: "Guesthome",
  components: {
    Gantt
  },
  data() {
    return {
      showBilling: true,
      model: {
        email: "",
        password: "",
        rememberMe: false
      },
      tasks: {
        data: [
          {
            id: 1,
            name: "Quote",
            duration: 2,
            progress: 0,
            start_date: "05-02-2019",
            task_id: "jaibajrangibali21597",
            //parent:1,
            assigned_to_client: {
              id: 99,
              first_name: "Suman",
              last_name: "Khatiwada",
              image: require("@/assets/img/theme/team-4.jpg")
            },
            assigned_by_client: {
              id: 99,
              first_name: "Suman",
              last_name: "Khatiwada",
              image: require("@/assets/img/theme/team-1.jpg"),
              prefix: "SK"
            },
            link_url: "project.html",
            which_task: "left",
            finance: "$ 17k"
          },
          {
            id: 2,
            name: "Approval",
            duration: 1,
            start_date: "09-02-2019",
            task_id: "jaibajrangibali21597",
            //parent:1,
            assigned_to_client: {
              id: 99,
              first_name: "Suman",
              last_name: "Khatiwada",
              image: require("@/assets/img/theme/team-4.jpg")
            },
            assigned_by_client: {
              id: 99,
              first_name: "Suman",
              last_name: "Khatiwada",
              image: require("@/assets/img/theme/team-3.jpg")
            },
            link_url: "project.html",
            finance: "$ 17k"
          },
          {
            id: 3,
            name: "Start",
            duration: 1,
            task_id: "jaibajrangibali21597",
            start_date: "14-02-2019",
            //parent:1,
            assigned_to_client: {
              id: 99,
              name: "Suman Khatiwada",
              avatar: require("@/assets/img/theme/team-4.jpg")
            },
            assigned_by_client: {
              id: 99,
              name: "Suman Khatiwada",
              avatar: require("@/assets/img/theme/team-2.jpg")
            },
            link_url: "project.html",
            finance: "$ 17k"
          },
          {
            id: 5,
            name: "Launch",
            duration: 1,
            task_id: "jaibajrangibali21597",
            start_date: "16-02-2019",
            //parent:1,
            assigned_to_client: {
              id: 99,
              first_name: "Suman",
              last_name: "Khatiwada",
              image: require("@/assets/img/theme/team-4.jpg")
            },
            assigned_by_client: {
              id: 99,
              first_name: "Suman",
              last_name: "Khatiwada",
              image: require("@/assets/img/theme/team-4.jpg")
            },
            link_url: "project.html",
            finance: "$17k"
          }
        ]
      }
    };

    // <span data-toggle="tooltip" data-trigger="hover" data-original-title="Suman Khatiwada" class="d-flex mr-1"><a href="#" class="avatar avatar-name avatar-sm   bg-success text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas"><img src="../assets/img/theme/team-4.jpg" class="rounded-circle"></a></span>',
  },
  computed: {
    ...mapState("project", ["demoProjects"]),
    ...mapState("user", ["profile"]),
    ...mapState(["ganttRender"])
  },
  watch: {
    ganttRender(val) {
      if (val) {
        this.fetchAllProjects();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchAllDemoProjects();
    });
  },
  methods: {
    ...mapActions("project", ["fetchAllDemoProjects"]),

    handleDblClick() {
      this.$emit("dblClick");
    }
  }
};
</script>
<style lang="scss">
.starter-page {
  min-height: calc(100vh - 380px);
}
.page-landing {
  .gantt_layout {
    .gantt_side_content {
      a:link {
        cursor: not-allowed;
      }
    }
  }
}
</style>
